import React, { useState, useEffect } from "react";
import styles from "../../../styles/components/cart.module.scss";
import Icons from "../../../public/assets/svg";
import BasicForm from "../../basicForm";
import { useRouter } from "next/router";
import axios from "axios";
import Loader from "../../Loader";
import _get from "lodash/get";
import {
  sessionTimeOutCheck,
  checkExpiry,
} from "../../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import UploadFileComponent from "../../uploadFileemptwin";
import endpoints from "../../../utility/endpoints";
import { BlobServiceClient } from "@azure/storage-blob";
const ModalExample = (props) => {
  //console.log("Props cart ---", props);

  const sucessFailure =
  props.data[1].component.content.field_message_type_value_pair;
  const modalRef = React.useRef(null);

  // method to close the modal if clicked outside
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          //props.closeModal();
        }
      }
      // Bind the event listener
      document.addEventListener("click", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("click", handleClickOutside);
      };
    }, [ref]);
  }
  useOutsideAlerter(modalRef);

  const router = useRouter();
  const goTo = (link) => {
    router.push(link);
  };
  
  const initialState = {
    "employeeTwinID": props.empid,
    "softSkillID": "",
    "skillName": "",
    "skillDescription": "",
    "status": "",
    "Profile": "",
    "engagementLeadEmail": "",
    "businessRequestorEmail": "",
    "uploadDocument": "anshudoclink"

  };
  const rawErrorData = {
    skillName: false,
    status: false,
    Profile: false,
    engagementLeadEmail: false,
    businessRequestorEmail: false,
    uploadDocument: false
}

  const [state, setState] = React.useState(initialState);
  const [stateError, setStateError] = useState(rawErrorData);
  const [items, setItems] = useState([]);
  const [sskillid,setSskillid]=React.useState("");

  const [submitForm, setSubmitForm] = React.useState(false);
  const [getFormValues, setGetFormValues] = React.useState(false);
  const [emptyFormValues, setEmptyFormValues] = React.useState(false);
  const [Loading, setLoading] = React.useState(false);
  /*Upload file code */
  const [file, setFile] = useState("");
  const [fileName, setFileName] = useState(null);
  const [showFileName, setShowFileName] = useState(false);
  const [fileError, setError] = useState(false);
  

  const [docfolder,setDocfolder]=("");
/*Dropdown Added by Anshu*/
  const requestDemoInfo = props.data[0].component.content;
  const {
    field_title,
    field_message_input,
    field_options,
    field_request_demo_form_componen,
  } = requestDemoInfo;



  const formComponents = field_request_demo_form_componen.filter(
    (item) => item.field_label != "Remarks"
  );

  const remarkComponent=props.data[0].component.content.field_request_demo_form_componen[0];
  const requesttype=props.data[0].component.content.field_request_demo_form_componen[1];
  const softskillid=props.data[0].component.content.field_request_demo_form_componen[2];
  const softskillname=props.data[0].component.content.field_request_demo_form_componen[3];
  const status=props.data[0].component.content.field_request_demo_form_componen[4];
  const profile=props.data[0].component.content.field_request_demo_form_componen[5];
  const engagementlead=props.data[0].component.content.field_request_demo_form_componen[6];
  const businessrequestor=props.data[0].component.content.field_request_demo_form_componen[7];
  const uploadDocument=props.data[0].component.content.field_request_demo_form_componen[8];
  const softskillForm = () => {
    setGetFormValues(true);
  };

  const onValueChange = async (e) => {
    const value = e.target.value;
    
      if((e.target.id=="engagementLeadEmail" ) && !validateEmail(e.target.value))
      {
        
      }
      else if(e.target.id=="businessRequestorEmail" && !validateEmail(e.target.value))
      {
        
      }
      else
      {
      setState({
        ...state,
        [e.target.id]: value,
      });
    
   
  }
    
    if (e.target.value ) {
      setStateError({ ...stateError, [e.target.id]: "valid" });
    } 
    else {
      setStateError({ ...stateError, [e.target.id]: true });
    }

}
// localStorage.setItem("item" , JSON.stringify(soft_skill_arr))
// localStorage.setItem("abc" , JSON.stringify(items))
let soft_skill_arr =[];
function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (re.test(String(email).toLowerCase())) {
    let emailAr = email.split("@");
    if (emailAr.length == 2) {
      if (emailAr[1] == "unilever.com") {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }

  // return re.test(String(email).toLowerCase());
}
  const onFromSubmit = async () => {
      
    
  };

  const handledemo = () => {
    props.closeModal();
    document.body.style.overflow = "unset";
  };
  //console.log("iteam_check------>" , items)
  // document upload code by Anshu

  const blobSasUrlNew = endpoints.blobSasUrlNew;

  const blobServiceClient = new BlobServiceClient(blobSasUrlNew);

  const containerClient = blobServiceClient.getContainerClient("employeetwin");
  //console.log(endpoints.blobsoftskillSasUrl, "fetchBlobemp");
  const uploadFile = async (file, name) => {
    //console.log(file);
    setShowFileName(true);

    let fileNameOriginal = file.name;
    //	setLoader(true)
    let fileNameWithSpaces = fileNameOriginal+Date.now();
    let fileName = fileNameWithSpaces.replace(/ /g, "");
    let ar = fileNameOriginal.split(".");
    let extension = ar[ar.length - 1];
    const fileSize = file.size;
    setLoading(true)
    try {
      const blockBlobClient = containerClient.getBlockBlobClient(fileName);
      const options = { blobHTTPHeaders: { blobContentType: file.type } };
      const resp = await blockBlobClient.uploadBrowserData(file, options);
      //console.log(resp, "response of azure");
      let url = resp._response.request.url;
      //console.log(url, "ye url chahiye");
      let ar = url.split("?");
      let another = ar[0].split("/");
      let toSend = another[another.length - 1];
      setFile(toSend);
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      setLoading(false)
      //console.log(extension, "ext", fileNameOriginal, "ori", toSend);
    } catch (error) {
      console.log(error, "erro");
      alert("Could not upload");
    }
  };

  const uploadButtonClick = async () => {
    //console.log("auth data state  ----");
    let formData = new FormData();
    if (file == null) {
      setError(true);
      return;
    } else {
      setError(false);
    }
    formData.append("empFile", file);
    setLoading(true);
    setloader(true);

    let authCheck = JSON.parse(localStorage.getItem("auth")).data;
    let expiryStatus = await props.checkExpiry(authCheck);

  };
  
 
  return (
    <div className={styles.editModalWrapper}>
      {Loading ? (
        <Loader />
      ) : (
        <div className={styles.modalBox} ref={modalRef}>
        <div className={`${styles.formContainer}`}>
          <div className="container">
          
            <div className="row">
              <div class="col-md-12">
              <span
                className={styles.rowBtn}
                onClick={() => {
                  handledemo();
                }}
              >
                <div className={styles.icon}>
                    <img src="https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/close.png" className={styles.iconimg}/>
                </div>
              </span>
              </div>
             
            </div>
            </div>
          </div>
         
          <div className={styles.modalBody}>
            
            <div className={styles.row}>
             
            </div>
            <div className={styles.row}>
              <div className="col-lg-12 col-md-12 col-12">
                <div className={styles.formGroup}>
                  
                  <div className={styles.formheading}>
                  <img src="https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/cart.png" className={styles.carticonimg}/>
                  <h2 className={styles.head}> Your <span>1 item</span> <br /> added to the cart!</h2>
                  </div>
                </div>
              </div>
            
            </div>
            {/* </div> */}
          </div>
          <div className={styles.modalFooter}>
            <div className={styles.combinedBtn}>
            <span
                className={styles.rowBtn}
                onClick={() =>
                    goTo(props.pageRoutes.Emptwincart)
                  }
              >
                View Cart
              </span>
              <span
                className={styles.exportListBtn}
                onClick={() =>
                    goTo(props.pageRoutes.Emptwincart)
                  }
              >
                Place an Order
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalExample);

